var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-header w", class: { "show-nav": _vm.showNav } },
    [
      _c("router-link", { staticClass: "logo", attrs: { to: "home" } }),
      _vm.isMobile && _vm.showNav
        ? _c("div", {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.showNav = false
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _vm._l(_vm.navList, function(item, index) {
            return _c(
              "a",
              {
                class: [
                  { "router-link-active": _vm.isActive(item.path) },
                  "delay" + index
                ],
                on: {
                  click: function($event) {
                    _vm.selectNav(item)
                  }
                }
              },
              [_vm._v(_vm._s(item.title))]
            )
          }),
          _c(
            "a",
            {
              staticClass: "delay6",
              attrs: { href: "http://en.flyingwings.cn/" }
            },
            [_vm._v("English")]
          )
        ],
        2
      ),
      _vm.isMobile && !_vm.showNav
        ? _c("div", {
            staticClass: "menu",
            on: {
              click: function($event) {
                _vm.showNav = true
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-045f21ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045f21ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-header.vue
// module id = IjzZ
// module chunks = 0